<template>
    <div>
        <div @click="isOpen = true;" class="pointer" style="max-height: 40px"><HistoryIcon :is-dark="isDark" :is-grey="isGrey"></HistoryIcon></div>

        <div v-if="isOpen">
            <ModalDefault
                size="m"
                :with-content="true"
                @close="isOpen = false;"
                :theme="true"
                :fix-height="false"
                :fix-width="false"
                :loading="loading"
            >
                <template slot="main">
                    <div class="history">
                        <p class="history-title">HISTORY</p>
                        <p class="history-subtitle" :style="{ color }">{{ objectType }} : {{ name ? name : object.name }}</p>
                        <p class="history-create-update mb-2 mt-4">
                            Creation: {{ object.createdBy.firstname }} {{ object.createdBy.lastname }} -
                            {{ getDateByFormat(object.createdDate, "lll") }}
                        </p>
                        <p class="history-create-update">
                            Modification: {{ object.modifiedBy.firstname }} {{ object.modifiedBy.lastname }} -
                            {{ getDateByFormat(object.modifiedDate, "lll") }}
                        </p>
                        <div class="table-responsive history-table-container">
                            <table class="table table-fit">
                                <tr v-for="history in histories">
                                    <td class="text-nowrap pl-0 border-0">{{ getDateByFormat(history.timestamp, "lll") }}</td>
                                    <td class="text-nowrap px-5 border-0">{{ history.user.firstname }} {{ history.user.lastname }}</td>
                                    <td class="text-left w-100 pr-0 border-0">{{ history.shortDescription }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </template>
            </ModalDefault>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.history {
    .history-title,
    .history-subtitle {
        font-family: "Oswald", Sans-Serif;
        text-align: center;
    }
    .history-title {
        font-size: 28px;
    }
    .history-subtitle {
        font-size: 24px;
    }
    .history-create-update {
        text-transform: initial;
        text-align: left;
        font-size: 16px;
        color: #999;
    }
    .history-table-container {
        max-height: 270px;
        overflow: auto;
        table {
            tr {
                td {
                    text-transform: initial;
                    font-size: 16px;
                }
            }
        }
    }
}
</style>
<script>
import HistoryIcon from "./HistoryIcon";
import historyService from "../../services/history";
import ModalDefault from "@/components/ui/ModalDefault";
import { mapGetters } from "vuex";

export default {
    components: { ModalDefault, HistoryIcon },
    props: {
        object: {
            type: Object,
            required: true
        },
        objectType: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: false,
            default: null
        },
        isDark: {
            type: Boolean,
            required: false,
            default: true
        },
        isGrey: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isOpen: false,
            loading: false,
            histories: []
        };
    },
    watch: {
        isOpen: function(isOpen) {
            if (isOpen) {
                this.loading = true;
                historyService
                    .getHistories(this.objectType, this.object.id)
                    .then(h => {
                        this.histories = h;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                        this.$swal({
                            text: "ERROR LOAD" + this.objectType.toUpperCase() + " HISTORY",
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "rgb(135, 135, 135)",
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        });
                    });
            }
        }
    },
    computed: {
        ...mapGetters({ getBrand: "brand/getBrand" }),
        color() {
            return this.getBrand.linksColor;
        }
    },
    methods: {},
    created() {}
};
</script>



// WEBPACK FOOTER //
// History.vue?23be141a